export default __webpack_public_path__ + "static/media/empty_state_mov.d3e846d1.svg";